// /Users/sunweibin/IdeaProjects/wms/wms-ai/wms-front/src/pages/SwitchWarehouse/index.tsx
import React, { useState, useEffect } from 'react';
import { Form, Input, Select, Button, message } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { authService } from '../../services/authService';

const SwitchWarehouse = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [warehouseList, setWarehouseList] = useState([]);
  const navigate = useNavigate();
  const { t } = useTranslation();

  // 获取用户信息和仓库列表
  useEffect(() => {
    fetchUserInfo();
  }, []);

  const fetchUserInfo = async () => {
    try {
      const response = await authService.userInfo();
      const userData = response.data;
      
      // 设置表单初始值
      form.setFieldsValue({
        userId: userData.userContext.account,
        nickname: userData.userContext.userName,
        currentWarehouse: userData.userContext.warehouseName,
        warehouseTimeZone: userData.userContext.warehouseTimeZone,
        targetWarehouse: userData.userContext.warehouseId,
      });
      
      // 设置仓库列表选项
      if (userData.warehouseList && userData.warehouseList.length > 0) {
        const options = userData.warehouseList.map(warehouse => ({
          value: warehouse.id,
          label: warehouse.name,
        }));
        setWarehouseList(options);
        
        // 设置默认选中的仓库
       form.setFieldsValue({
            targetWarehouse: userData.userContext.warehouseId,
          });
      }
    } catch (error) {
      message.error(t('switchWarehouse.fetchUserInfoFailed'));
    }
  };

  const handleSubmit = async (values) => {
    try {
      setLoading(true);
      const payload = {
        warehouseId: values.targetWarehouse,
        warehouseCode: values.targetWarehouseCode,
        warehouseName: values.targetWarehouseName,
        warehouseTimeZone: values.warehouseTimeZone,
        accountId: values.userId,
      };
      
      await authService.updateCurrentWarehouse(payload);
      message.success(t('switchWarehouse.switchSuccess'));
    } catch (error) {
      message.error(t('switchWarehouse.switchFailed'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: '24px', maxWidth: '800px', margin: 'auto' }}>
      <h2>{t('switchWarehouse.title')}</h2>
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        initialValues={{
          targetWarehouse: undefined,
        }}
      >
        <Form.Item
          label={t('switchWarehouse.userId')}
          name="userId"
          rules={[{ required: true, message: t('switchWarehouse.userIdRequired') }]}
        >
          <Input disabled />
        </Form.Item>
        
        <Form.Item
          label={t('switchWarehouse.nickname')}
          name="nickname"
          rules={[{ required: true, message: t('switchWarehouse.nicknameRequired') }]}
        >
          <Input disabled />
        </Form.Item>
        
        <Form.Item
          label={t('switchWarehouse.currentWarehouse')}
          name="currentWarehouse"
          rules={[{ required: true, message: t('switchWarehouse.currentWarehouseRequired') }]}
        >
          <Input disabled />
        </Form.Item>
        
        
        <Form.Item
          label={t('switchWarehouse.targetWarehouse')}
          name="targetWarehouse"
          rules={[{ required: true, message: t('switchWarehouse.targetWarehouseRequired') }]}
        >
          <Select
            showSearch
            placeholder={t('switchWarehouse.targetWarehousePlaceholder')}
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.value == input || option.label == input
            }
            options={warehouseList}
          />
        </Form.Item>
        
        <Form.Item>
          <Button type="primary" htmlType="submit" loading={loading}>
            {t('switchWarehouse.confirm')}
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default SwitchWarehouse;